<div class="lui-dual-avatar-primary">
  <ng-content select="[luiAvatarPrimary]"></ng-content>
</div>
<div class="lui-dual-avatar-secondary">
  <div class="lui-dual-avatar-secondary-aligner">
    <div class="lui-dual-avatar-secondary-offset">
      <ng-content select="[luiAvatarSecondary]"></ng-content>
    </div>
  </div>
</div>
